export default {
      id: "play.sprite-usage",
      viewBox: "0 0 22 26",
      url: __webpack_public_path__ + "sprite.svg#play.sprite-usage",
      toString: function () {
        return this.url;
      }
    }